import { render } from "./PWAUpdatePrompt.vue?vue&type=template&id=28c7385d"
import script from "./PWAUpdatePrompt.vue?vue&type=script&lang=js"
export * from "./PWAUpdatePrompt.vue?vue&type=script&lang=js"

import "./PWAUpdatePrompt.vue?vue&type=style&index=0&id=28c7385d&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.2.13_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__